export default __webpack_public_path__ + "static/media/LinkedIn_collaboration-and-approvals_tool.95b683a3.svg";